"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var EmailExclusives_1 = require("../components/ShopAll/EmailExclusives");
var targetNode = document.querySelector('.email-exclusives-section');
if (targetNode && window.preactShopAllProducts && window.preactSubHeaders) {
    (0, preact_1.render)((0, preact_1.h)(EmailExclusives_1.default, { products: window.preactShopAllProducts, subHeaders: window.preactSubHeaders, bundleDiscount: window.preactBundleDiscount }), targetNode);
}
